export const FIRST_PLAYER = 0
export const SECOND_PLAYER = 1
